module.exports = __webpack_public_path__ + "../resources/img/@temp_news_photo_02.2dcbad27.jpg";